<div class="car">
  @if (preSignedUrl) {
    <img
      [hidden]="!photoLoaded"
      [ngClass]="{ 'car-img-custom-size': repairerTile, 'car-img-small-size': rego, 'car-img': true }"
      [src]="preSignedUrl"
      (error)="photoLoaded = false"
      (load)="photoLoaded = true" />
  }
  @if (!preSignedUrl || !photoLoaded) {
    <mat-icon
      class="car-placeholder"
      [ngClass]="{
        'car-placeholder-small-size': rego && !repairerTile,
        'car-placeholder-custom-size': repairerTile
      }"
      svgIcon="car_placeholder_icon" />
  }
  @if (rego) {
    <div
      class="body-2 rego-span"
      [ngClass]="{
        'car-rego-top-spaced': preSignedUrl && !repairerTile,
        'car-rego-top-spaced-13': preSignedUrl && repairerTile,
        'car-rego-padding-added': repairerTile
      }">
      {{ rego }}
    </div>
  }
</div>
